module.exports = __webpack_public_path__ + "static/media/bright-bg-short.066ccaa5.png";